import Hotjar from '@hotjar/browser';

const siteId = 2853153;
const hotjarVersion = 6;

Hotjar.init(siteId, hotjarVersion);
